<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col sm="12" lg="12" v-if="tagsOptions.length > 0">
        <b-form-group>
          <label>{{$t("views.exsborder.list.tags")}}: </label>
          <multi-select :options="tagsOptions" :selected-options="item.userDataTags" @select="onSelectTags" >
          </multi-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_name"
                  class="form-control-label">{{ $t('views.userdata.form.name') }}:</label>
          <input
                  id="userdata_name"
                  v-model="item.name"
                  :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('name', $event.target.value)">
          <div
                  v-if="isInvalid('name')"
                  class="invalid-feedback">{{ violations.name }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4" >
        <div class="form-group">
          <label
                  for="userdata_surname"
                  class="form-control-label">{{ $t('views.userdata.form.surname') }}:</label>
          <input
                  id="userdata_surname"
                  v-model="item.surname"
                  :class="['form-control', isInvalid('surname') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('surname', $event.target.value)">
          <div
                  v-if="isInvalid('surname')"
                  class="invalid-feedback">{{ violations.surname }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_idClientType"
                  class="form-control-label">{{ $t('views.userdata.form.idClientType') }}:</label>
          <model-select :options="clientTypesOptions" v-model="item.idClientType"></model-select>
          <div
                  v-if="isInvalid('idClientType')"
                  class="invalid-feedback">{{ violations.idClientType }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_birthday"
                  class="form-control-label">{{ $t('views.userdata.form.birthday') }}:</label>
          <fg-input :error="violations.birthday">
            <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    v-model="item.birthday"
                    type="date">
            </el-date-picker>
          </fg-input>
          <div
                  v-if="isInvalid('birthday')"
                  class="invalid-feedback">{{ violations.birthday }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_birthplace"
                  class="form-control-label">{{ $t('views.userdata.form.birthplace') }}:</label>
          <input
                  id="userdata_birthplace"
                  v-model="item.birthplace"
                  :class="['form-control', isInvalid('birthplace') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('birthplace', $event.target.value)">
          <div
                  v-if="isInvalid('birthplace')"
                  class="invalid-feedback">{{ violations.birthplace }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="3">
        <div class="form-group">
          <label
                  for="userdata_street"
                  class="form-control-label">{{ $t('views.userdata.form.street') }}:</label>
          <input
                  id="userdata_street"
                  v-model="item.street"
                  :class="['form-control', isInvalid('street') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('street', $event.target.value)">
          <div
                  v-if="isInvalid('street')"
                  class="invalid-feedback">{{ violations.street }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="1">
        <div class="form-group">
          <label
            for="userdata_streetnumber"
            class="form-control-label">{{ $t('views.userdata.form.streetNumber') }}:</label>
          <input
            id="userdata_street"
            v-model="item.streetNumber"
            :class="['form-control', isInvalid('streetNumber') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('streetNumber', $event.target.value)">
          <div
            v-if="isInvalid('streetNumber')"
            class="invalid-feedback">{{ violations.streetNumber }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_city"
                  class="form-control-label">{{ $t('views.userdata.form.city') }}:</label>
          <input
                  id="userdata_city"
                  v-model="item.city"
                  :class="['form-control', isInvalid('city') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('city', $event.target.value)">
          <div
                  v-if="isInvalid('city')"
                  class="invalid-feedback">{{ violations.city }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_postcode"
                  class="form-control-label">{{ $t('views.userdata.form.postcode') }}:</label>
          <input
                  id="userdata_postcode"
                  v-model="item.postcode"
                  :class="['form-control', isInvalid('postcode') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('postcode', $event.target.value)">
          <div
                  v-if="isInvalid('postcode')"
                  class="invalid-feedback">{{ violations.postcode }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_mobilePhone"
                  class="form-control-label">{{ $t('views.userdata.form.mobilePhone') }}:</label>
          <input
                  id="userdata_mobilePhone"
                  v-model="item.mobilePhone"
                  :class="['form-control', isInvalid('mobilePhone') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('mobilePhone', $event.target.value)">
          <div
                  v-if="isInvalid('mobilePhone')"
                  class="invalid-feedback">{{ violations.mobilePhone }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_province"
                  class="form-control-label">{{ $t('views.userdata.form.province') }}:</label>
          <input
                  id="userdata_province"
                  v-model="item.province"
                  :class="['form-control', isInvalid('province') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('province', $event.target.value)">
          <div
                  v-if="isInvalid('province')"
                  class="invalid-feedback">{{ violations.province }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_country"
                  class="form-control-label">{{ $t('views.userdata.form.country') }}:</label>
          <input
                  id="userdata_country"
                  v-model="item.country"
                  :class="['form-control', isInvalid('country') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('country', $event.target.value)">
          <div
                  v-if="isInvalid('country')"
                  class="invalid-feedback">{{ violations.country }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_pesel"
                  class="form-control-label">{{ $t('views.userdata.form.pesel') }}:</label>
          <input
                  id="userdata_pesel"
                  v-model="item.pesel"
                  :class="['form-control', isInvalid('pesel') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('pesel', $event.target.value)">
          <div
                  v-if="isInvalid('pesel')"
                  class="invalid-feedback">{{ violations.pesel }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_nip"
                  class="form-control-label">{{ $t('views.userdata.form.nip') }}:</label>
          <input
                  id="userdata_nip"
                  v-model="item.nip"
                  :class="['form-control', isInvalid('nip') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('nip', $event.target.value)">
          <div
                  v-if="isInvalid('nip')"
                  class="invalid-feedback">{{ violations.nip }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="userdata_userEmail"
                  class="form-control-label">{{ $t('views.userdata.form.userEmail') }}:</label>
          <input
                  id="userdata_userEmail"
                  v-model="item.userEmail"
                  :class="['form-control', isInvalid('userEmail') ? 'is-invalid' : '']"
                  type="email"
                  placeholder=""
                  @input="handleUpdateField('userEmail', $event.target.value)">
          <div
                  v-if="isInvalid('userEmail')"
                  class="invalid-feedback">{{ violations.userEmail }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_contactEmail"
            class="form-control-label">{{ $t('views.userdata.form.contactEmail') }}:</label>
          <input
            id="userdata_contactEmail"
            v-model="item.contactEmail"
            :class="['form-control', isInvalid('contactEmail') ? 'is-invalid' : '']"
            type="email"
            placeholder=""
            @input="handleUpdateField('contactEmail', $event.target.value)">
          <div
            v-if="isInvalid('contactEmail')"
            class="invalid-feedback">{{ violations.contactEmail }}</div>
        </div>
      </b-col>
      <b-col v-if="workplacesOptions.length > 0" sm="12" lg="4">
        <div :class="['form-group', isInvalid('workplace') ? 'has-danger' : '']">
          <label
            for="userdata_idWorkplace"
            class="form-control-label">{{$t('views.firm.form.idWorkplace')}}:</label>
          <model-select :options="workplacesOptions" v-model="item.workplace"></model-select>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_avatar"
            class="form-control-label">{{ $t('views.userdata.form.customSymbol') }}:</label>
          <input
            id="userdata_avatar"
            v-model="item.customSymbol"
            :class="['form-control', isInvalid('customSymbol') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('customSymbol', $event.target.value)">
          <div
            v-if="isInvalid('avatar')"
            class="invalid-feedback">{{ violations.customSymbol }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_salesRepresentative"
            class="form-control-label">{{ $t('views.userdata.form.idSalesRepresentative') }}:</label>
          <base-select-input
            v-model="item.idSalesRepresentative"
            :search-callback="getSalesRepresentativesCallback"
            :display-values="['fullName']"
            :query-param="'userdata'"
            :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
        </div>
      </b-col>
      <b-col cols="12" lg="2">
        <div class="form-group">
          <label
                  for="excmuserdatastatus_userDataColor"
                  class="form-control-label">{{$t('views.userdata.form.userDataColor')}}:</label><br>
          <el-color-picker v-model="item.userDataColor"></el-color-picker>
          <div
                  v-if="isInvalid('userDataColor')"
                  class="invalid-feedback">{{ violations.userDataColor }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="12">
        <div class="form-group">
          <label
                  for="userdata_extraInfo"
                  class="form-control-label">{{ $t('views.userdata.form.extraInfo') }}:</label>
          <textarea
                  id="userdata_extraInfo"
                  v-model="item.extraInfo"
                  :class="['form-control', isInvalid('extraInfo') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('extraInfo', $event.target.value)"></textarea>
          <div
                  v-if="isInvalid('extraInfo')"
                  class="invalid-feedback">{{ violations.extraInfo }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import { ModelSelect, MultiSelect } from 'vue-search-select'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'

export default {
  components: { BaseSelectInput, ModelSelect, MultiSelect },

  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      routeName: '',
      clientTypesOptions: [],
      workplacesOptions: [],
      tagsOptions: [],
      userAccount: {}
    }
  },

  created () {
    this.routeName = this.$route.name
    this.getClientTypes()
    this.channelClientTypes = this.$store.state.Pusher.subscribe('client_types')
    this.channelClientTypes.bind('client_types', data => {
      this.getClientTypes()
    })
    this.getWorkplaces()
    this.getTags()
    this.createMobilePhoneUserDataWatcher()
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('client_types')
  },

  computed: {
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    }
  },

  methods: {
    destroyMobilePhoneUserDataWatcher () {
      this.unwatchMobilePhoneUserData()
    },
    createMobilePhoneUserDataWatcher () {
      this.unwatchMobilePhoneUserData = this.$watch(
        function () {
          return this.item.mobilePhone
        },
        function (newValue, oldValue) {
          this.mobilePhoneValidate(newValue, oldValue)
        }
      )
    },
    mobilePhoneValidate (value, oldValue) {
      this.destroyMobilePhoneUserDataWatcher()
      if (value !== oldValue) {
        let newValue = value.replace(/[a-z]/gi, '')
        let newValueArray = []
        if (!newValue.includes('+48 ')) {
          newValue = '+48 '
        } else if ((newValue.length === 7 && oldValue.length === 6) || (newValue.length === 11 && oldValue.length === 10)) {
          newValue += ' '
        } else if (newValue.slice(-1) === ' ' && newValue.length > 4) {
          newValue = newValue.substring(0, newValue.length - 1)
        } else if ((newValue.length === 8 && oldValue.length === 7) || (newValue.length === 12 && oldValue.length === 11)) {
          newValueArray = newValue.split('')
          newValue = ''
          for (let i in newValueArray) {
            if (i < (newValueArray.length - 1)) {
              newValue += newValueArray[i]
            } else {
              newValue += ' ' + newValueArray[i]
            }
          }
        } else if (value.length > 15) {
          newValue = newValue.substring(0, 15)
        }
        this.item.mobilePhone = newValue
      }
      this.createMobilePhoneUserDataWatcher()
    },

    closeModal () {
      this.$store.state.modals.userdata.create.close = 1
    },
    async getClientTypes () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('client_types', params).getResults()
      this.clientTypesOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async getWorkplaces () {
      let params = { 'pagination': false }
      this.workplacesOptions = [{ text: this.$t('global.notSet'), value: null }]
      const response = await new ApiService('e_x_c_m_user_data_workplaces', params).getResults()
      response.items.forEach(entry => {
        this.workplacesOptions.push({ text: entry.title, value: entry['@id'] })
      })
    },
    async getTags () {
      let params = { 'pagination': false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      response.items.forEach(entry => {
        this.tagsOptions.push({ text: entry.tag, value: entry['@id'] })
      })
    },
    async getSalesRepresentativesCallback (params = {}) {
      let baseParams = { pagination: false, idClientType: 4 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    getIdLink (link) {
      return getId(link)
    },
    onSelectTags (items, lastSelectItem) {
      this.item.userDataTags = items
      this.lastSelectTag = lastSelectItem
    }
  }
}
</script>
